// Module
var code = "<div class=\"ibox-title toggle-title\"> <h5>{{title}}</h5> <div class=\"ibox-tools\" uib-dropdown> <a><i class=\"fa fa-chevron-down\"></i></a> </div> </div> ";
// Exports
module.exports = code;